import * as React from 'react';
import * as toastr from 'toastr';

import { Button } from '../../components/buttons';
import { Validation, InputError, SecurityRoles } from '../../common/utils';
import { connect } from 'react-redux';
import { CheckboxGroup } from '../../components/forms';
import userActions from '../../user/userActions';
import authActions from '../../auth/authActions';
import { bindActionCreators } from 'redux';
import { CheckboxProps } from '../../components/forms/Checkbox';

const AUTHROLE_PICKLISTTYPEID = '363eb8930518e811992f00155d74f005';

interface Props {
	className?: string;
	actions: any;
	user: UserDetails;
	roles: PickListItem[];
}
interface State {
	email?: string;
	touched: {
		email: boolean;
	};
}
class ResetPasswordPage extends React.Component<Props, State> {
	errors = { email: {} as InputError };

	constructor(props: any) {
		super(props);
		this.state = {
			email: '',
			touched: {
				email: false
			}
		};
	}
	componentDidMount() {
		this.setState({ email: this.props.user.email });
	}

	send = () => {
		const resetUrl = this.props.actions.getResetPasswordUrlForEmail();
		this.props.actions.resetPassword(this.props.user.id, resetUrl).then(() => {
			toastr.info('Password reset email sent!');
		});
	}
	isSendDisabled = () => {
		return this.errors.email.hasError;
	}
	validate = () => {
		// true means invalid
		return {
			email: Validation.validateEmail(this.state.email)
		};
	}

	saveRole = () => {
		this.props.actions.saveRole(this.props.user.id, this.props.user.role).then(() => {
			toastr.info('Role updated!');
		});
	}

	isChecked = (name: string, roles: string[] | undefined) => {
		if (!roles) {
			return false;
		}
		else {
			return roles.indexOf(name) > -1;
		}
	}
	createCheckOptions = () => {
		const checkOptions: Array<CheckboxProps> = [
			{
				name: SecurityRoles.Administrator,
				label: 'Administrator',
				checked: this.isChecked(SecurityRoles.Administrator, this.props.user.role),
				onChange: this.onCheckedChange
			},
			{
				name: SecurityRoles.Agent,
				label: 'Agent',
				checked: this.isChecked(SecurityRoles.Agent, this.props.user.role),
				onChange: this.onCheckedChange
			},
			{
				name: SecurityRoles.Adjudicator,
				label: 'Adjudicator',
				checked: this.isChecked(SecurityRoles.Adjudicator, this.props.user.role),
				onChange: this.onCheckedChange
			},
			{
				name: SecurityRoles.Customer,
				label: 'Customer',
				checked: this.isChecked(SecurityRoles.Customer, this.props.user.role),
				onChange: this.onCheckedChange
			}];

		return checkOptions;
	}
	onCheckedChange = (e: any) => {
		// handle old user's without a role array prop
		let roles: string[] = [];
		if (this.props.user.role && Array.isArray(this.props.user.role)) {
			roles = [...this.props.user.role];
		}
		if (e.target.checked) {
			roles.push(e.target.name);
		}
		else {
			roles = roles.filter(x => x !== e.target.name);
		}

		const user = {
			...this.props.user,
			role: roles
		};

		this.props.actions.setUser(user);
	}

	render() {
		this.errors = this.validate();
		return (
			<div className={this.props.className}>
				<h2 className="form-fieldset-title">Change Role</h2>
				<div className="form-fieldset">
					<CheckboxGroup
						title="Role"
						// values={JSON.stringify(this.props.user.role) || ''}
						name="role"
						checkOptions={this.createCheckOptions()}
					/>
					<Button onClick={this.saveRole} className="btn-primary">
						Save role
					</Button>
				</div>
				<h2 className="form-fieldset-title mt-4">Reset Password</h2>
				<div className="form-fieldset">
					<p>
						Click the button to send a password recovery email to <strong>{this.state.email}</strong>.
					</p>
					<Button onClick={this.send} disabled={this.isSendDisabled()} className="btn-primary">
						Send email
					</Button>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state: any, ownProps: any) {
	return {
		user: state.user.user,
		roles: state.pickList.items.filter((p: PickListItem) => p.pickListTypeId === AUTHROLE_PICKLISTTYPEID),
	};
}
function mapDispatchToProps(dispatch: any) {
	const actions = { ...userActions, ...authActions };
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordPage);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/admin/common/SecurityPage.tsx